/*
 * Tutorials Messages
 *
 * This contains all the text for the Tutorials component.
 */

import { defineMessages } from 'react-intl';
export const scope = 'src.pages.SetupPage.components.Tutorials';

export default defineMessages({
  searchPlaceholder: {
    id: `${scope}.searchPlaceholder`,
    defaultMessage: 'Title',
  },
  titleEnColumnLabel: {
    id: `${scope}.titleEnColumnLabel`,
    defaultMessage: 'Title (en)',
  },
  titleDeColumnLabel: {
    id: `${scope}.titleDeColumnLabel`,
    defaultMessage: 'Title (de)',
  },
  positionColumnLabel: {
    id: `${scope}.positionColumnLabel`,
    defaultMessage: 'Position',
  },
  editTooltip: {
    id: `${scope}.editTooltip`,
    defaultMessage: 'Edit',
  },
  deleteTooltip: {
    id: `${scope}.deleteTooltip`,
    defaultMessage: 'Delete',
  },
  deleteCategoryConfirmation: {
    id: `${scope}.deleteCategoryConfirmation`,
    defaultMessage: 'Are you sure you want to delete this category?',
  },
});
